import { get, has, set, unset } from 'lodash/fp'

import { ListGroup } from 'common-components'

import { Component as Checkbox } from './index'

const Component = ({ value, options, setValue }) => {
  const onChange = (option) => {
    console.log('onChange', option)
    const key = get('value')(option)
    const hasKey = has(key)(value)
    const newOptions = hasKey ? unset(key)(value) : set(key, option)(value)
    setValue(newOptions)
  }
  return (
    <ListGroup
      value={value}
      options={options}
      onChange={onChange}
      isActive={(option) => {
        const key = get('value')(option)
        return has(key)(value)
      }}
      render={(props) => <Checkbox defaultChecked={false} {...props} />}
    />
  )
}

export default (hoc) => Component
